import { Component, ReactNode, Ref } from 'react';
import { Positioner } from '@optimus-web/helpers';
import { TooltipProps } from '../Tooltip';
import { noop } from '../utils/func';
import { CalendarService } from '../utils/services';
import CalendarMonth from './CalendarMonth';
import CalendarMonthGridAnimator from './CalendarMonthGridAnimator';

export interface CalendarMonthGridProps<D, M, Y> {
    endDate?: D | null;
    focusedDate: D;
    getCalendarService: () => CalendarService<D, M, Y>;
    month: M;
    months: Array<M>;
    monthSelectedIndex: number;
    monthSelectorVisible: boolean;
    numberOfMonths: number;
    allowDisabledClick?: boolean;
    areSurroundingDaysOfSingleMonthHidden?: boolean;
    innerRef?: Ref<HTMLElement | null>;
    isSingleDaySelectionCircle?: boolean;
    onDateClick?: (event: React.MouseEvent, date: D) => void;
    startDate?: D;
    startDateWithTooltip?: TooltipProps;
    dayWithTooltipRef?: React.Ref<Positioner>;
    getDateTooltip?: (day: D) => ReactNode | undefined;
    isMobile?: boolean;
    tooltipDelay?: number;
}

export default class CalendarMonthGrid<D, M, Y> extends Component<CalendarMonthGridProps<D, M, Y>> {
    render() {
        const {
            endDate,
            focusedDate,
            innerRef,
            getCalendarService,
            month,
            months,
            monthSelectorVisible,
            monthSelectedIndex,
            onDateClick,
            startDate,
            startDateWithTooltip,
            dayWithTooltipRef,
            getDateTooltip,
            isMobile,
            ...other
        } = this.props;

        const props = {
            innerRef,
            getCalendarService,
            month,
            isMobile,
        };

        return (
            <CalendarMonthGridAnimator {...props}>
                {months.map((m) => {
                    const monthName = getCalendarService().getMonthName(m);

                    return (
                        <CalendarMonth
                            {...other}
                            endDate={endDate}
                            onDateClick={onDateClick ?? noop}
                            key={monthName}
                            month={m}
                            getCalendarService={getCalendarService}
                            focusedDate={focusedDate}
                            monthSelectorVisible={monthSelectorVisible}
                            monthSelectedIndex={monthSelectedIndex}
                            startDate={startDate}
                            startDateWithTooltip={startDateWithTooltip}
                            dayWithTooltipRef={dayWithTooltipRef}
                            getDateTooltip={getDateTooltip}
                            isMobile={isMobile}
                        />
                    );
                })}
            </CalendarMonthGridAnimator>
        );
    }
}
